const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

/**
 * Compact "how long ago" label for dense UI (history rows, activity lists) where the full
 * timestamp would be noise — "now", "4m", "3h", "2d", "5w", then a plain date past ~a year.
 *
 * Deliberately abbreviated rather than prose ("4 minutes ago"): these render right-aligned in
 * narrow columns and must not wrap.
 */
export function formatRelativeTime(timestamp: number, now: number = Date.now()): string {
  const elapsed = now - timestamp;

  // Clock skew or an optimistic future timestamp — don't render "-3m".
  if (elapsed < MINUTE) return 'now';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}m`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}h`;
  if (elapsed < WEEK) return `${Math.floor(elapsed / DAY)}d`;
  if (elapsed < 52 * WEEK) return `${Math.floor(elapsed / WEEK)}w`;

  return new Date(timestamp).toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}
